import { Component, Input } from "@angular/core";

@Component({
  selector: "app-products-dropdown",
  templateUrl: "./products-dropdown.component.html",
  styleUrls: ["./products-dropdown.component.scss"],
})
export class ProductsDropdownComponent {
  @Input() isDropdownVisible = false;

  isClick: boolean = true;

  openClose() {
    if (this.isClick) {
      this.isDropdownVisible = !this.isDropdownVisible;
    }
  }
}
